<template>
    <brick-base class="brick-square" @click="$emit('click', $event)">
        <slot />
    </brick-base>
</template>

<script>
    import BrickBase from './BrickBase.vue';
    
    export default {
        name: 'brick-square-base',
        components: {
            BrickBase
        }
    }
</script>

<style scoped lang="scss">
    @import "~@modules/JourneyBuilder/Style/brick-square-base.scss";
</style>